import { Chip } from '@/components/commons/chip'
import { ErrorBox } from '@/components/commons/error-box'
import { GalleryImageItem } from '@/components/commons/gallery-image-item'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { AlertTriangleIcon, Trash01Icon } from '@/components/ui/icons'
import { OpsVettingGalleryItemsContainer } from '@/features/ops-vetting/components/ops-vetting-atoms'
import { CircularProgressBar } from '@/features/service-vetting/components/circular-progress-bar'
import {
	type GalleryItem,
	useExperienceVettingPhotoUpload
} from '@/features/service-vetting/store/services-photo-upload.ts'
import { useTranslation } from '@/translations/i18n.tsx'
export const ExpVettingCriteriaGalleryUploadingItem = ({
	image,
	hideAction
}: {
	image: GalleryItem
	hideAction: boolean
}) => {
	const { t } = useTranslation()
	const uploadProgressValues = useExperienceVettingPhotoUpload(
		(store) => store.uploadProgressValues
	)
	const deleteGalleryItem = useExperienceVettingPhotoUpload(
		(store) => store.deleteGalleryItem
	)

	const onClickDeletePhoto = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation()
		deleteGalleryItem(image.id)
	}

	return (
		<OpsVettingGalleryItemsContainer>
			<GalleryImageItem
				bottomLeftSlot={
					<Chip
						label={t(
							'vetting:criteria.service.gallery.internal_upload'
						)}
						variant={'neutral'}
					/>
				}
				centerSlot={
					image.status === 'pending' ? (
						<CircularProgressBar
							progress={uploadProgressValues[image.id] || 0}
						/>
					) : (
						image.status === 'error' && (
							<ErrorBox
								icon={<AlertTriangleIcon />}
								title={t('errors:default')}
							/>
						)
					)
				}
				hasBlur={image.status !== 'uploaded'}
				src={image.thumbnails?.xs || image.url}
				topRightSlot={
					<ButtonLegacy
						disabled={hideAction}
						onClick={onClickDeletePhoto}
						shape='square'
						type='button'
						variant={'secondary'}
					>
						<Trash01Icon />
					</ButtonLegacy>
				}
			/>
		</OpsVettingGalleryItemsContainer>
	)
}
